export enum CdocFormat {
    pdf = "pdf",
    rtf = "rtf",
    file = "xxcdoc_SaveAndTicket_file",
    attachDoc = "xxcdoc_StartrekAttachDoc_file"
}
